import React from 'react'
import { Row, Col, Card, /*Button*/ } from 'antd'
import { translate } from 'react-i18next'


const Package = ({ t }) => {
    return (
        <section className="sec1">
            <Row>
                <Col span={24} className="package-title">
                    <h1>{t("menu_package")}</h1>
                    {/* eslint-disable-next-line */}
                    <img src={process.env.PUBLIC_URL + `/img/logo-vroom.png`} />
                    <h3>Meet at Home</h3>
                </Col>
            </Row>
            <Row type="flex" justify="center">
                <Col xs={24} sm={24} md={8} lg={5}>
                    <div className="package-card">
                        <Card title={t('package_list_guest.package_name')} bordered={true} style={{ width: '100%' }}>
                            <h3>{t("package_free")}</h3>
                            {/* <p className="no-signup">{t('package_list_guest.package_hilight')}</p> */}
                            {/* <p className="package-content">
                                Meeting duration limit <span className="red-text">40</span> mins up to  <span className="red-text">10</span> participants
                            </p> */}
                            <span className="package-feature">{t('package_feature')}</span>
                            <ul>
                                <li>{t('package_list_guest.feature_detail1')}</li>
                                <li>{t('package_list_guest.feature_detail2')}</li>
                                <li>{t('package_list_guest.feature_detail3')}</li>
                            </ul>
                            <span>{t('package_support_device')}</span>
                            <ul>
                                <li>{t('package_list_guest.support_device1')}</li>
                                <li>{t('package_list_guest.support_device2')}</li>
                            </ul>
                        </Card>
                    </div>
                </Col>
                <Col xs={24} sm={24} md={8} lg={5}>
                    <div className="package-card">
                        <Card title={t('package_list_registered-user.package_name')} bordered={true} style={{ width: '100%' }}>
                            <h3>{t("package_free")}</h3>
                            {/* <Button type="primary" className="btn-signup" danger disabled>{t('package_list_registered-user.package_hilight')}</Button> */}
                            {/* <p className="package-content">
                                Meeting duration limit <span className="red-text">60</span>  mins up to <span className="red-text">10</span> participants
                            </p> */}
                            <span className="package-feature">{t('package_feature')}</span>
                            <ul>
                                <li>{t('package_list_registered-user.feature_detail1')}</li>
                                <li>{t('package_list_registered-user.feature_detail2')}</li>
                                <li>{t('package_list_registered-user.feature_detail3')}</li>
                                <li><span className="red-text">{t('package_list_registered-user.feature_detail4')}</span></li>
                            </ul>
                            <span>{t('package_support_device')}</span>
                            <ul>
                                <li>{t('package_list_registered-user.support_device1')}</li>
                                <li>{t('package_list_registered-user.support_device2')}</li>
                            </ul>
                        </Card>
                    </div>
                </Col>
            </Row>
        </section>
    )
}

export default translate()(Package)
